const featuredInLogos = [
  'https://joybird2.imgix.net/static-v1/design-services-page/logo_washington-post.svg',
  'https://joybird2.imgix.net/static-v1/design-services-page/logo_apartment-therapy.svg',
  'https://joybird2.imgix.net/static-v1/design-services-page/logo_hgtv.svg',
  'https://joybird2.imgix.net/static-v1/design-services-page/logo_wsj.svg',
  'https://joybird2.imgix.net/static-v1/design-services-page/logo_nytimes.svg',
  'https://joybird2.imgix.net/static-v1/design-services-page/logo_elle-decor.svg',
];

export default featuredInLogos;
